$(document).ready(function () {
  var messegeCarousel = $(".messegeCarousel");
  messegeCarousel.owlCarousel({
    loop: true,
    margin: 10,
    dots: false,
    nav: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $(".nextBtn").click(function () {
    messegeCarousel.trigger("next.owl.carousel");
  });

  $(".prevBtn").click(function () {
    messegeCarousel.trigger("prev.owl.carousel");
  });
  //  mega menu new settings code start
  // $(".navbar-item.has-mega-menu").click(function () {
  //   // $("#header").toggleClass("makeItFixed");
  // });
  // mega menu new settings code end

  // featured collection carousel code start

  // for desktop settings

  var deskSlideToShow = $(".ftCollectionContainer").attr("data-slide");
  var finalDeskSlideToShow = parseInt(deskSlideToShow);

  var productSliderContainer = $(".productSliderContainer");
  productSliderContainer.owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsiveClass: true,
    items: finalDeskSlideToShow,
  });

  $(".deskNext").click(function () {
    productSliderContainer.trigger("next.owl.carousel");
  });

  $(".deskPrev").click(function () {
    productSliderContainer.trigger("prev.owl.carousel");
  });

  // for mobile settings
  var slideToShow = $(".ftCollectionContainerMob").attr("data-slide");
  var finalSlideToShow = parseInt(slideToShow);
  var productSliderContainerMob = $(".productSliderContainerMob");
  productSliderContainerMob.owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsiveClass: true,
    items: finalSlideToShow,
  });

  $(".mobNext").click(function () {
    productSliderContainerMob.trigger("next.owl.carousel");
  });

  $(".mobPrev").click(function () {
    productSliderContainerMob.trigger("prev.owl.carousel");
  });

  productSliderContainer.on("changed.owl.carousel", function (e) {
    $(".deskNext").removeClass("disabledBtn");
    $(".deskPrev").removeClass("disabledBtn");
  });
  productSliderContainerMob.on("changed.owl.carousel", function (e) {
    $(".mobPrev").removeClass("disabledBtn");
    $(".mobNext").removeClass("disabledBtn");
    
  });

  // featured collection carousel code end

  // testimonial carousel code start
  var testimonialSecCarousel = $(".testimonialSecCarousel");
  testimonialSecCarousel.owlCarousel({
    margin: 10,
    dots: false,
    nav: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        loop: true,
      },
      600: {
        items: 2,
        loop: true,
      },
      1000: {
        items: 3,
        loop: false,
      },
    },
  });

  $(".testNext").click(function () {
    testimonialSecCarousel.trigger("next.owl.carousel");
  });

  $(".testPrev").click(function () {
    testimonialSecCarousel.trigger("prev.owl.carousel");
  });

  testimonialSecCarousel.on("changed.owl.carousel", function (e) {
    $(".testNext").removeClass("disabledBtn");
    $(".testPrev").removeClass("disabledBtn");
  });

  // testimonial carousel code end

  // blog post section carousel start

  var blogSlideToShow = $(".blogPostMobSlider").attr("data-slide");
  var finalBlogSlideToShow = parseInt(blogSlideToShow);
  var blogSlider = $(".blogSlider");
  blogSlider.owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: false,
    responsiveClass: true,
    items: finalBlogSlideToShow,
  });

  $(".blogMobNxt").click(function () {
    blogSlider.trigger("next.owl.carousel");
  });

  $(".blogMobPrev").click(function () {
    blogSlider.trigger("prev.owl.carousel");
  });

  blogSlider.on("changed.owl.carousel", function (e) {
    $(".blogMobPrev").removeClass("disabledBtn");
    $(".blogMobNxt").removeClass("disabledBtn");
  });
  // blog post section carousel end

  // faq page tabs code start
  $(".tabMainBtn").click(function () {
    $(".tabMainBtn").removeClass("activeTabBtn");
    $(this).addClass("activeTabBtn");
    var accordianContent = $(this).attr("data-id");
    $(".faqCatContentItem").hide();
    $(accordianContent).show();
  });

  $(".accordianBtn").click(function () {
    $(".accordianBtn").not(this).parent().removeClass("openAccordian");
    $(this).parent().toggleClass("openAccordian");
  });
  // faq page tabs code end

  // price range filter code start
  var maxValue = $("#amount2").val();

  $("#slider-range").slider({
    range: true,
    min: 0,
    max: maxValue,
    step: 1,
    values: [0, maxValue],
    slide: function (event, ui) {
      $("#amount1").val(ui.values[0]);
      $("#amount2").val(ui.values[1]);
        $("#amount3").val(ui.values[0]);
      $("#amount4").val(ui.values[1]);
    },
  });

  $("#amount1").val($("#slider-range").slider("values", 0));
  $("#amount2").val($("#slider-range").slider("values", 1));
  $("#amount3").val($("#slider-range").slider("values", 0));
  $("#amount4").val($("#slider-range").slider("values", 1));

  $("button.mobileMenuOpener").click(function () {
    $("header#header").toggleClass("activeMenuDrawer");
    $("html").toggleClass("dontScroll");
  });

  $("button.filterOpener").click(function () {
    $("aside.sideBarContainer").addClass("showFilters");
  });
  $("button.closeFiltersBtn").click(function () {
    $("aside.sideBarContainer").removeClass("showFilters");
  });

  // price range filter code end

  $(".listViewBtn").click(function () {
    $(".takeSide").addClass("showListView");

    $(".gridViewBtn").removeClass("activeView");
    $(".listViewBtn").addClass("activeView");
  });
  $(".gridViewBtn ").click(function () {
    $(".gridViewBtn").addClass("activeView");
    $(".listViewBtn").removeClass("activeView");
    $(".takeSide").removeClass("showListView");
  });

  // collection page code end

  $(".mobile-menu__toggle-icon").click(function () {
    $(this).toggleClass("is-active");
    $(".mobileMenuSettings").removeClass("activeLvlMenu");
    $("html").removeClass("dontScroll");
  });


  // mobile mega menu code start 
  $(".aboveMenuImg h2").click(function () {
    $(this).next(".mobileMenuSettings").addClass("activeLvlMenu");
    $("html").addClass("dontScroll");
  });
  $(".closeSecondLvlMenu").click(function () {
    $(".mobileMenuSettings").removeClass("activeLvlMenu");
    $("html").removeClass("dontScroll");
  });

  
  // mobile mega menu code end 





  // product page thumbnail slider 

 $(".slider-main").slick({
    slidesToShow: 1,
    arrows: false,
    asNavFor: ".slider-nav",
    vertical: true,
    autoplay: false,
    verticalSwiping: true,
    centerMode: false,
  });
  if ($(window).width() > 1000) {
    $(".slider-nav").slick({
      slidesToShow: 4,
      arrows: false,
      asNavFor: ".slider-main",
      vertical: true,
      focusOnSelect: true,
      verticalSwiping: false,
      autoplay: false,
      centerMode: false,
    });
  } else {
    $(".slider-nav").slick({
      slidesToShow: 3,
      arrows: false,
      asNavFor: ".slider-main",
      vertical: true,
      focusOnSelect: true,
      verticalSwiping: false,
      autoplay: false,
      centerMode: false,
    });
  }
  //on resizing the window fix to broken responsiveness
  $(window).on("resize orientationchange", function () {
    $(".slider-main").slick("unslick");
    $(".slider-nav").slick("unslick");

    $(".slider-main").slick({
      slidesToShow: 1,
      arrows: false,
      asNavFor: ".slider-nav",
      vertical: true,
      autoplay: false,
      verticalSwiping: true,
      centerMode: false,
    });
    if ($(window).width() > 1000) {
      $(".slider-nav").slick({
        slidesToShow: 5,
        asNavFor: ".slider-main",
        arrows: false,
        vertical: true,
        focusOnSelect: true,
        verticalSwiping: false,
        autoplay: false,
        centerMode: false,
      });
    } else {
      $(".slider-nav").slick({
        slidesToShow: 3,
        asNavFor: ".slider-main",
        arrows: false,
        vertical: true,
        focusOnSelect: true,
        verticalSwiping: false,
        autoplay: false,
        centerMode: false,
      });
    }
  });


  $(".nav-container .next").click(function () {
    $(".slider-nav").slick("slickNext");
  });

  $(".mainNext").click(function () {
    $(".slider-main").slick("slickNext");
  });


  $(".nav-container .prev").click(function () {
    $(".slider-nav").slick("slickNext");
  });

  $(".mainPrevBtn").click(function () {
    $(".slider-main").slick("slickPrev");
  });

  



});

$("#claas").click(function () {
  $("#claa").css("display", "none");
});
$("#claas").click(function () {
  $("#claas").css("display", "none");
});
$("#claas").click(function () {
  $("#login").css("display", "none");
});
$("#claas").click(function (){
  $("#reset-heading").css("display","block")
})
$("#forget-password").click(function () {
  $("#claa").css("display", "none");
});
$("#forget-password").click(function () {
  $("#claas").css("display", "none");
});
$("#show-text").click(function () {
  $("#claa").css("display", "block");
});
$("#show-text").click(function () {
  $("#claas").css("display", "block");
});

$("#login-again").click(function () {
  $("#claa").css("display", "block");
});
$("#login-again").click(function () {
  $("#login").css("display", "block");
});

$("#login-again").click(function () {
  $("#reset-heading").css("display", "none");
});
$("#login-againn").click(function () {
  $("#reset-heading").css("display", "none");
});
$("#login-againn").click(function () {
 $("#login").css("display", "block");
});
$("#login-againn").click(function () {
 $("#claa").css("display", "block");
});
$("#login-againn").click(function () {
 $("#claas").css("display", "block");
});



$("#toggle").click(function () {
 $('html, body').css({
    overflow: 'hidden',

});
});




$("#unsroll").click(function (){
$('html, body').css({
    overflow: 'auto',
  
});
});


$("#toggle").click(function (){
 $('#ssw-widget-review-bar').css("display", "none")

})

$("#unsroll").click(function (){
 $('#ssw-widget-review-bar').css("display", "block")

});



$("#toggle").click(function (){
 $('#ssw-fave-list-widget').css("display", "none")

})

$("#unsroll").click(function (){
 $('#ssw-fave-list-widget').css("display", "block")

});




$("#toggle").click(function (){
 $('.ssw-reward-tab.ssw-reward-tab-left').css("display", "none")

})

$("#unsroll").click(function (){
 $('.ssw-reward-tab.ssw-reward-tab-left').css("display", "block")

});

/*
$('.owl-carousel').on('changed.owl.carousel', function(e) {

    $('button.owl-next').removeAttr('disabled');
    $('button.owl-prev').removeAttr('disabled');

    if ( ( e.page.index + 1 ) >= e.page.count ){
        $('button.owl-next').attr('disabled', 'disabled');
    } else {
        $('button.owl-next').removeAttr('disabled');
    }
    
    if ( e.page.index == 0 ){
        $('button.owl-prev').attr('disabled', 'disabled');
    } else {
        $('button.owl-prev').removeAttr('disabled');
    }

});
*/
$(document).ready(function() {
  $("#popup-button").click(function() {
    $("#popup-content").show();
  });
  $("#close-button").click(function() {
    $("#popup-content").hide();
  });
});
$(document).ready(function() {
  $("#popup-button").click(function() {
    $("#popup-content").show();
    $("#overlay").show();
  });
  $("#close-button").click(function() {
    $("#popup-content").hide();
    $("#overlay").hide();
  });
});

 $("#overlay").click(function() {
    $("#popup-content").hide();
    $("#overlay").hide();
  });



function zoom(e){
  var zoomer = e.currentTarget;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
  x = offsetX/zoomer.offsetWidth*100
  y = offsetY/zoomer.offsetHeight*100
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

$('.related').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:false
        },
        1000:{
            items:3,
            nav:true,
            loop:false
        }
    }
})


